/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marketing_All_PostsInputs */

const en_marketing_all_posts = /** @type {(inputs: Marketing_All_PostsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All posts`)
};

const es_marketing_all_posts = /** @type {(inputs: Marketing_All_PostsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todos los artículos`)
};

const fr_marketing_all_posts = /** @type {(inputs: Marketing_All_PostsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tous les articles`)
};

/**
* | output |
* | --- |
* | "All posts" |
*
* @param {Marketing_All_PostsInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" }} options
* @returns {LocalizedString}
*/
export const marketing_all_posts = /** @type {((inputs?: Marketing_All_PostsInputs, options?: { locale?: "en" | "es" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marketing_All_PostsInputs, { locale?: "en" | "es" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_marketing_all_posts(inputs)
	if (locale === "es") return es_marketing_all_posts(inputs)
	return fr_marketing_all_posts(inputs)
});